export const columnSum = (data: unknown[], columnId: string): unknown =>
  data.reduce<number>((acc, item) => acc + Number(item[columnId] ?? 0), 0);
